<template>
  <div>
    <nav class="c-mypageMenu">
      <div v-if="(isProvider || (isBlogger && hasFetchedBlogger)) && !isBusiness">
        <h1 class="c-mypageMenu_title">出品者メニュー</h1>
        <ul>
          <li
            class="c-mypageMenu_link"
            :class="{ 'c-mypageMenu_link-current': current === 'dashboard_provider' }"
          >
            <NuxtLink to="/mypage/dashboard_provider?ref=menu">
              出品者ダッシュボード
              <coconala-icon
                name="chevron-right"
                size="12px"
              />
            </NuxtLink>
          </li>
          <li
            class="c-mypageMenu_link"
            :class="{ 'c-mypageMenu_link-current': current === 'services/search' }"
          >
            <a href="/mypage/received_orders/open?ref=menu">
              販売取引(トークルーム) / 見積り
              <coconala-icon
                name="chevron-right"
                size="12px"
              />
            </a>
          </li>
          <li
            class="c-mypageMenu_link"
            :class="{ 'c-mypageMenu_link-current': current === 'services/offers' }"
          >
            <a href="/mypage/offers?ref=menu">
              公開依頼への提案
              <coconala-icon
                name="chevron-right"
                size="12px"
              />
            </a>
          </li>
          <li
            class="c-mypageMenu_link"
            :class="{ 'c-mypageMenu_link-current': current === 'services_lists' }"
          >
            <a href="/mypage/services_lists?ref=menu">
              出品サービス管理
              <coconala-icon
                name="chevron-right"
                size="12px"
              />
            </a>
          </li>
          <li
            class="c-mypageMenu_link"
            :class="{ 'c-mypageMenu_link-current': current === 'pservices_lists' }"
            v-if="hasPhoneService"
          >
            <a href="/mypage/pservices_lists?ref=menu">
              出品サービス管理(電話)
              <coconala-icon
                name="chevron-right"
                size="12px"
              />
              <span
                class="c-phoneLabel"
                v-if="phoneEndTime > 0"
              >
                待機中
              </span>
              <span
                class="c-phoneLabel c-phoneLabel-away"
                v-else
              >
                退席中
              </span>
            </a>
          </li>
          <li
            class="c-mypageMenu_link"
            :class="{ 'c-mypageMenu_link-current': current === 'analytics' }"
          >
            <NuxtLink to="/mypage/analytics?ref=menu">
              サービス・ブログ分析
              <coconala-icon
                name="chevron-right"
                size="12px"
              />
            </NuxtLink>
          </li>
          <li
            class="c-mypageMenu_link c-mypageMenu_link-new"
          >
            <NuxtLink to="/mypage/promotion?ref=menu">
              広告管理
              <CoconalaIcon
                name="chevron-right"
                size="12px"
              />
            </NuxtLink>
          </li>
          <li
            class="c-mypageMenu_link"
            :class="{ 'c-mypageMenu_link-current': current === 'mypage/blogs' }"
          >
            <NuxtLink to="/mypage/blogs?ref=menu">
              ブログ管理
              <coconala-icon
                name="chevron-right"
                size="12px"
              />
            </NuxtLink>
          </li>
          <li
            class="c-mypageMenu_link"
            :class="{ 'c-mypageMenu_link-current': current === 'revenue' }"
          >
            <a href="/mypage/revenue?ref=menu">
              売上管理・振込申請
              <coconala-icon
                name="chevron-right"
                size="12px"
              />
            </a>
          </li>
          <li
            class="c-mypageMenu_link"
            :class="{ 'c-mypageMenu_link-current': current === 'followers' }"
          >
            <NuxtLink to="/mypage/received_favorites?ref=menu">
              あなた宛のお気に入り
              <coconala-icon
                name="chevron-right"
                size="12px"
              />
            </NuxtLink>
          </li>
        </ul>
      </div>
      <!-- 個人・出品アカウント時の購入者メニュー -->
      <template v-if="!isBusiness">
        <h1 class="c-mypageMenu_title">購入者メニュー</h1>
        <ul>
          <li
            class="c-mypageMenu_link"
            :class="{ 'c-mypageMenu_link-current': current === 'dashboard' }"
          >
            <NuxtLink to="/mypage/dashboard?ref=menu">
              購入者ダッシュボード
              <coconala-icon
                name="chevron-right"
                size="12px"
              />
            </NuxtLink>
          </li>
          <li
            class="c-mypageMenu_link"
            :class="{ 'c-mypageMenu_link-current': current === 'orders/search' }"
          >
            <a href="/mypage/orders/requests?ref=menu">
              購入取引(トークルーム) / 見積り
              <coconala-icon
                name="chevron-right"
                size="12px"
              />
            </a>
          </li>
          <li
            class="c-mypageMenu_link"
            :class="{ 'c-mypageMenu_link-current': current === 'mypage/requests' }"
          >
            <a href="/mypage/requests?ref=menu">
              仕事・相談の公開依頼
              <coconala-icon
                name="chevron-right"
                size="12px"
              />
            </a>
          </li>
          <li
            class="c-mypageMenu_link"
            :class="{ 'c-mypageMenu_link-current': current === 'mypage/blog_orders' }"
          >
            <NuxtLink to="/mypage/blog_orders?ref=menu">
              購入ブログ
              <coconala-icon
                name="chevron-right"
                size="12px"
              />
            </NuxtLink>
          </li>
          <li
            class="c-mypageMenu_link"
            :class="{ 'c-mypageMenu_link-current': current === 'mypage/favorites' }"
          >
            <a href="/mypage/favorites?ref=menu">
              お気に入り
              <coconala-icon
                name="chevron-right"
                size="12px"
              />
            </a>
          </li>
          <li
            class="c-mypageMenu_link"
            :class="{ 'c-mypageMenu_link-current': current === 'points/top' }"
          >
            <a href="/points/top?ref=menu">
              ポイント / クーポン
              <coconala-icon
                name="chevron-right"
                size="12px"
              />
            </a>
          </li>
          <li
            class="c-mypageMenu_link"
            :class="{ 'c-mypageMenu_link-current': current === 'points' }"
          >
            <a href="/points?ref=menu">
              コイン購入・確認
              <coconala-icon
                name="chevron-right"
                size="12px"
              />
            </a>
          </li>
        </ul>
        <div class="c-mypageMenu_divider"></div>
        <c-button
          :href="$coconala.url('/services/add')"
          class="c-mypageMenu_btn"
          size="medium"
          color="primary-green"
          is-bold
          is-full
        >
          出品する
        </c-button>
      </template>
      <!-- ビジネスアカウント時のメニュー -->
      <template v-else>
        <div class="c-mypageMenu_divider"></div>
        <ul>
          <li
            class="c-mypageMenu_link"
            :class="{ 'c-mypageMenu_link-current': current === 'dashboard' }"
          >
            <NuxtLink to="/mypage/dashboard?ref=menu">
              ダッシュボード
              <coconala-icon
                name="chevron-right"
                size="12px"
              />
            </NuxtLink>
          </li>
          <li
            class="c-mypageMenu_link"
            :class="{ 'c-mypageMenu_link-current': current === 'projects' }"
          >
            <NuxtLink to="/business/projects">
              プロジェクト
              <coconala-icon
                name="chevron-right"
                size="12px"
              />
            </NuxtLink>
          </li>
          <li
            class="c-mypageMenu_link"
            :class="{ 'c-mypageMenu_link-current': current === 'orders/search' }"
          >
            <a href="/mypage/orders/requests?ref=menu">
              購入取引(トークルーム) / 見積り
              <coconala-icon
                name="chevron-right"
                size="12px"
              />
            </a>
          </li>
          <li
            class="c-mypageMenu_link"
            :class="{ 'c-mypageMenu_link-current': current === 'mypage/favorites' }"
          >
            <a href="/mypage/favorites?ref=menu">
              お気に入り
              <coconala-icon
                name="chevron-right"
                size="12px"
              />
            </a>
          </li>
          <li
            class="c-mypageMenu_link"
            :class="{ 'c-mypageMenu_link-current': current === 'enterprise' }"
          >
            <NuxtLink to="/enterprise/orders">
              チーム
              <coconala-icon
                name="chevron-right"
                size="12px"
              />
            </NuxtLink>
          </li>
          <li
            class="c-mypageMenu_link"
            :class="{ 'c-mypageMenu_link-current': current === 'mypage/requests' }"
          >
            <a href="/mypage/requests?ref=menu">
              公開依頼
              <coconala-icon
                name="chevron-right"
                size="12px"
              />
            </a>
          </li>
          <li
            class="c-mypageMenu_link"
            :class="{ 'c-mypageMenu_link-current': current === 'mypage/blog_orders' }"
          >
            <NuxtLink to="/mypage/blog_orders?ref=menu">
              購入ブログ
              <coconala-icon
                name="chevron-right"
                size="12px"
              />
            </NuxtLink>
          </li>

          <li
            class="c-mypageMenu_link"
            :class="{ 'c-mypageMenu_link-current': current === 'points/top' }"
          >
            <a href="/points/top?ref=menu">
              ポイント・クーポン・コイン
              <coconala-icon
                name="chevron-right"
                size="12px"
              />
            </a>
          </li>
        </ul>
        <div class="c-mypageMenu_divider"></div>
      </template>
      <ul>
        <li class="c-mypageMenu_link">
          <NuxtLink to="/switch_account">
            {{ !isBusiness ? "ビジネスアカウントへ切替" : "個人・出品アカウントへ切替" }}
            <CoconalaIcon
              name="chevron-right"
              size="12px"
            />
          </NuxtLink>
        </li>
        <template v-if="!isBusiness">
          <li
            class="c-mypageMenu_link"
            :class="{
              'c-mypageMenu_link-current': current === 'mypage/invite',
              'c-mypageMenu_link-invite' : isViralCampaign
            }"
          >
            <NuxtLink to="/mypage/invite">
              {{ campaignText.main }}
              <CoconalaIcon
                name="chevron-right"
                size="12px"
              />
              <span
                v-if="campaignText.sub"
                class="c-mypageMenu_subTitle"
                :class="{ 'c-mypageMenu_subTitle-campaign': isViralCampaign }"
              >{{ campaignText.sub }}</span>
            </NuxtLink>
          </li>
          <li
            class="c-mypageMenu_link"
            v-if="!isMypageSp"
          >
            <NuxtLink to="/mypage/blogs?new=true">
              ブログを投稿する
              <coconala-icon
                name="chevron-right"
                size="12px"
              />
            </NuxtLink>
          </li>
        </template>
        <li
          class="c-mypageMenu_link"
          :class="{ 'c-mypageMenu_link-current': 'message' === current }"
        >
          <NuxtLink to="/message?fromMyPage=true">
            メッセージ
            <coconala-icon
              name="chevron-right"
              size="12px"
            />
          </NuxtLink>
        </li>
        <li
          v-if="isBusiness"
          class="c-mypageMenu_link"
          :class="{ 'c-mypageMenu_link-current': 'business/settings' === current }"
        >
          <NuxtLink to="/business/settings">
            ビジネス設定
            <coconala-icon
              name="chevron-right"
              size="12px"
            />
          </NuxtLink>
        </li>
        <li
          class="c-mypageMenu_link"
          :class="{ 'c-mypageMenu_link-current': 'user_account' === current }"
        >
          <a :href="$coconala.url('/mypage/user_account')">
            {{ !isBusiness ? "設定" : "基本設定" }}
            <coconala-icon
              name="chevron-right"
              size="12px"
            />
          </a>
        </li>
        <li class="c-mypageMenu_link">
          <a :href="$coconala.url('/logout')">
            ログアウト
          </a>
        </li>
      </ul>
    </nav>
    <div class="c-sideBanner">
      <a
        href="https://mag.coconala.com/?ref=pc_footer_mag"
        target="_blank"
      >
        <img
          src="@/assets/images/common/banner/mag.png"
          alt="coconala mag"
          width="232"
          loading="lazy"
        >
      </a>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { isViralCampaign, campaignText } from '~/components/logics/viral-campaign'

export default {
  name: 'MypageMenu',
  props: {
    current: {
      type: String,
      default: 'services/search'
    },
    isMypageSp: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isViralCampaign: isViralCampaign(),
      campaignText: campaignText()
    }
  },
  computed: {
    ...mapState('auth/user', ['isProvider', 'isBusiness']),
    ...mapState('my/header', ['isBlogger', 'hasPhoneService', 'phoneEndTime', 'hasFetchedBlogger'])
  },
  mounted() {
    // TheHeaderで取得しない場合があるためhasFetchedBloggerが必須のタイミングで取得する
    this.$store.dispatch('my/header/fetchIsBlogger')
  }
}
</script>

<style lang="scss" scoped>
.c-mypageMenu {
  &_title {
    margin: 20px 0 4px;
    border-bottom: 1px solid $color-gray-200;
    font-size: 12px;
  }
  &_link {
    position: relative;
    line-height: 40px;
    a {
      @include link-effect;

      display: block;
      color: $color-font-base;
      font-size: 14px;
      i {
        position: absolute;
        top: 14px;
        right: 0;
        color: $color-gray-600;
      }
    }
    &-current {
      font-weight: bold;
      a {
        i {
          color: $color-font-base;
        }
      }
    }
    &-new {
      position: relative;
      &::after {
        position: absolute;
        top: -16px;
        left: 0;
        display: block;
        color: $color-pink-500;
        content: 'NEW!';
        font-size: 11px;
      }
    }
    &-invite {
      a {
        color: $ds2-color-brand-secondary;
      }
    }
  }
  &_subTitle {
    position: absolute;
    top: -15px;
    left: 0;
    color: $ds2-color-orange-700;
    font-size: 11px;
    &-campaign {
      color: $ds2-color-pink;
    }
  }
  &_divider {
    margin: 12px 0;
    border-top: 1px solid $color-gray-200;
  }
  &_btn {
    @include link-effect;

    margin-bottom: 12px;
  }
}

.c-phoneLabel {
  padding: 2px 4px;
  border-radius: 2px;
  background-color: $ds2-color-orange;
  color: $ds2-color-white;
  font-size: 10px;

  &-away {
    border: 1px solid $color-gray-300;
    background-color: $color-gray-50;
    color: $color-gray-700;
  }
}

.c-sideBanner {
  @include link-effect;

  margin: 24px 0;
  text-align: center;
}
</style>
